import { getChannel, thisWindowId } from './broadcasting';
import { opsViewActions } from 'reducers/opsViewSlice';
import { streamingActions } from 'reducers/streamingSlice';
import { setMapBoundingBox } from 'reducers/mapSlice';

//Broadcast only user actions that need to be synced between windows
const actionsToBroadcast = [...opsViewActions, ...streamingActions, setMapBoundingBox.type];

export const broadcastMiddleware = store => next => action => {
	const incomingSenderId = action.meta?.senderId;
	const channel = getChannel();

	if (incomingSenderId) {
		// Skip processing if:
		// - we're the main window and action came from main window
		// - we're the popout window and action came from popout window
		if (incomingSenderId === thisWindowId) {
			// console.log('skipped broadcast', action);
			return next(action);
		}
	}
	// For non-broadcasted actions, broadcast them if they're in our list
	else if (actionsToBroadcast.includes(action.type)) {
		// console.log(thisWindowId, ' - is broadcasting action', action);
		channel.postMessage({ ...action, meta: { ...(action.meta || {}), senderId: thisWindowId } });
	}

	return next(action);
};
